<template>
	<div class="dev-dash">
		<dev-pushes />
		<dev-builds />
		<dev-ooo />
		<dev-pulls />
	</div>
</template>

<script>
	import DevPushes from './dev-pushes.vue';
	import DevBuilds from './dev-builds.vue';
	import DevOoo from './dev-ooo.vue';
	import DevPulls from './dev-pulls.vue';

	export default {
		name: 'DevDash',
		components: {
			DevPushes,
			DevBuilds,
			DevOoo,
			DevPulls
		},

		mounted() {
			console.log("Development dashboard module initiated");
		},
		
		destroyed() {
			console.log("Stopping Development dashboard module");
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	.dev-dash {
		font-family: @font-main;
		padding: 0;
		height: 100%;
		color: #fff;
		display: flex;
		flex-flow: column wrap;
	}
</style>


// WEBPACK FOOTER //
// dev-dash.vue?43effa4a